import { Swiper } from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

export class MainBanner {
	private element: HTMLElement;
	private sliderElement: HTMLElement;
	private paginationElement: HTMLElement;
	private slider: Swiper;
	private sliderSettings = (): SwiperOptions => ({
		modules: [Autoplay, Pagination],
		loop: true,
		slidesPerView: 1,
		autoplay: {
			delay: 5000,
		},
		pagination: {
			el: this.paginationElement,
		}
	});

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.sliderElement = this.element.querySelector('.main-banner__slider');
		this.paginationElement = this.element.querySelector('.main-banner__pagination');

		this.init();
	}

	public init = (): void => {
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
	};
}
